import { CLIENTES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    saldo_cliente: null,
    ventana_filtros: false,
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CLIENTES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case CLIENTES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case CLIENTES.PAQUETES:
            return {
                ...state,
                detalles: {
                    ...state.detalles,
                    contrataciones_paquetes: payload
                }
            };

        case CLIENTES.SALDO:
            return {
                ...state,
                saldo_cliente: payload
            };

        case CLIENTES.PAGOS:
            return {
                ...state,
                detalles: {
                    ...state.detalles,
                    pagos: payload.pagos,
                    indicadores_generales: {
                        ...state.detalles.indicadores_generales,
                        saldo: payload.saldo
                    }
                }
            };

        case CLIENTES.MEMBRESIA:
            return {
                ...state, 
                detalles: {
                    ...state.detalles, 
                    indicadores_generales: {
                        ...state.detalles.indicadores_generales, 
                        membresia_actual: payload
                    }, 
                    contrataciones_membresias: [
                        payload,
                        ...state.detalles.contrataciones_membresias.slice(payload.status == 0 ? 0 : 1)
                    ]
                }
            };

        case CLIENTES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( joven => joven._id !== payload.id )
            };

        case CLIENTES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        default:
            return state;
    }
}